import React, { useEffect, useState } from 'react';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import stylesAlert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';
import { DoneAll, Close, Visibility, Create } from '@material-ui/icons';
import SweetAlert from 'react-bootstrap-sweetalert';

import Button from 'components/CustomButtons/Button.js';

import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...stylesAlert,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  table: {
    minWidth: 1400
  },
  totals: {
    '& td': {
      fontWeight: '500'
    }
  }
}));

const columns = [
  { field: 'num', width: 50, header: '#' },
  { field: 'ItemCode', width: 130, header: 'Código' },
  { field: 'ItemName', width: 300, header: 'Producto' },
  { field: 'units_package', align: 'right', width: 130, header: 'Cant.X.Paq.' },
  { field: 'commited_units', align: 'right', width: 130, header: 'Unids.Compr.' },
  { field: 'diference_units', width: 120, header: 'Sin Stok' },
  { field: 'packages', align: 'right', width: 90, header: 'Paquetes' },
  { field: 'units', align: 'right', width: 80, header: 'Unids' },
  { field: 'units_price', align: 'right', width: 90, header: 'P./Und.' },
  { field: 'package_price', align: 'right', width: 90, header: 'P./Paq.' },
  { field: 'amount', align: 'right', width: 100, header: 'Importe' },
  { field: 'type', width: 120, header: 'Tipo' },
  { field: 'promotion_type', width: 130, header: 'Promoción' },
  { field: 'state', width: 130, header: 'Estado' }
];

export default WithApp(function ResponseData(props) {
  const classes = useStyles();
  const { responseData, setAlertAprobed, approveOrCancel, updateOrder, continuar } = props;

  //#region --- funcion para mostrar alert de confirmacion al aprobar o anular

  const hideAlert = () => {
    setAlertAprobed(null);
  };
  function confirmChange(text, status) {
    setAlertAprobed(
      <SweetAlert
        warning={status}
        input={status === false ? true : false}
        style={{ display: 'block', marginTop: '-100px' }}
        title={'¿Esta seguro de ' + text + ' ?'}
        onConfirm={(e) => {
          if (status) {
            approveOrCancel(status);
          } else {
            approveOrCancel(status, { ObservacionError: e });
          }
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {status ? ' ¡Esta acción tiene consecuencias!' : 'Ingrese el motivo por favor :)'}
      </SweetAlert>
    );
  }
  //#endregion

  const [totals, setTotals] = useState({
    packages: 0,
    units: 0,
    amount: 0
  });

  function calcTotals() {
    if (responseData?.details.length > 0) {
      let packages = 0;
      let units = 0;
      let amount = 0;
      for (let obj of responseData.details) {
        packages += parseFloat(obj.packages);
        units += parseFloat(obj.units);
        amount += parseFloat(obj.amount);
      }
      setTotals({
        packages: packages,
        units: units,
        amount: amount
      });
    }
  }

  useEffect(() => {
    calcTotals();
  }, []);

  return (
    <Card>
      <CardBody>
        <TableContainer component={Paper}>
          <Table className={classes.table} size="small">
            <TableHead>
              <TableRow>
                {columns.map((item, i) => {
                  return (
                    <TableCell key={i} width={item.width} align={item.align}>
                      {item.header}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {responseData?.details.map((obj, i) => {
                return (
                  <TableRow
                    key={i}
                    style={{
                      backgroundColor: obj.promotion_id !== null ? '#09c75e66' : 'none',
                    }}
                  >
                    <TableCell>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {i + 1}
                        {obj.promotion_id !== null ? (
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColor}
                            size="sm"
                            className={classes.marginRight}
                            onClick={() => {
                              window.open(
                                '/admin/articulos/operaciones/promociones/' + obj.promotion_id,
                                '_blank',
                              );
                            }}
                          >
                            <Visibility className={classes.icons} />
                          </Button>
                        ) : undefined}
                      </div>
                    </TableCell>
                    <TableCell>{obj.ItemCode}</TableCell>
                    <TableCell>{obj.ItemName}</TableCell>
                    <TableCell align="right">{obj.units_package}</TableCell>
                    <TableCell style={{ backgroundColor: '#ff8b001f' }}>
                      {obj.commited_units}
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{ color: obj.diference_units > 0 ? 'red' : 'black' }}
                    >
                      {obj.diference_units}
                    </TableCell>
                    <TableCell align="right">{obj.packages}</TableCell>
                    <TableCell align="right">{obj.units}</TableCell>
                    <TableCell align="right">
                      {!isNaN(obj.units_price) ? parseFloat(obj.units_price).toFixed(2) : 0}
                    </TableCell>
                    <TableCell align="right">
                      {!!obj.package_price ? parseFloat(obj.package_price).toFixed(2) : 0}
                    </TableCell>
                    <TableCell align="right">
                      {!!obj.amount ? parseFloat(obj.amount).toFixed(2) : 0}
                    </TableCell>
                    <TableCell>
                      {obj.type === 'N'
                        ? 'Nomal'
                        : obj.type === 'B'
                        ? 'Bonificación'
                        : 'No definido'}
                    </TableCell>
                    <TableCell>
                      {obj.promotion_type !== null
                        ? obj.promotion_type == 'P'
                          ? 'Producto-' + obj.promotion_id
                          : obj.promotion_type == 'D'
                          ? 'Descuento-' + obj.promotion_id
                          : 'No definido'
                        : 'No aplica'}
                    </TableCell>
                    <TableCell>
                      {obj.state === 'X'
                        ? 'Nomal'
                        : obj.state === 'S'
                        ? 'Sin stock'
                        : obj.state === 'R'
                        ? 'Retenido'
                        : 'No definido'}
                    </TableCell>
                  </TableRow>
                );
              }) || []}
              <TableRow className={classes.totals}>
                <TableCell colSpan={6} align="right">
                  Total:
                </TableCell>
                <TableCell align="right">{totals.packages}</TableCell>
                <TableCell align="right">{totals.units}</TableCell>
                <TableCell colSpan={3} align="right">
                  {totals.amount.toFixed(2)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
          {responseData.order.state === 'R' ? (
            <>
              <span>Pedido retenido</span>
              <ul>
                {responseData.order.retention_reasons.split(',').map((reason, index) => {
                  return <li key={index}>{reason}</li>;
                })}
              </ul>
                
              <Button
                color={props.themeContext.buttonColorWarning}
                style={{ marginRight: '20px' }}
                onClick={continuar}
              >
                <Create /> Ok
              </Button>
            </>
          ) : (
            <>
              <Button
                color={props.themeContext.buttonColorWarning}
                style={{ marginRight: '20px' }}
                onClick={() => updateOrder()}
              >
                <Create /> Editar
              </Button>
              <Button
                color={props.themeContext.buttonColorSuccess}
                onClick={() => {
                  confirmChange('Aprobar', true);
                }}
              >
                <DoneAll /> Aprobar
              </Button>
              <Button
                color={props.themeContext.buttonColorDanger}
                style={{ marginLeft: '20px' }}
                onClick={() => {
                  confirmChange('Anular', false);
                }}
              >
                <Close /> Anular
              </Button>
            </>
          )}
        </div>
      </CardBody>
    </Card>
  );
});
